import $ from 'jquery'

jQuery(document).ready(function($) {
  

    // $('.add_to_cart_button').on('click', function() {
    //     var product_id = $(this).data('product_id');
    //     var quantity = $(this).data('quantity');
    //     var data = {
    //         action: 'add_to_cart',
    //         product_id: product_id,
    //         quantity: quantity
    //     };
    //     $.ajax({
    //         type: 'POST',
    //         url: wc_add_to_cart_params.ajax_url,
    //         data: data,
    //         beforeSend: function() {
    //             // Add loading spinner or other indicator here
    //         },
    //         success: function(response) {
    //             // Update the cart content here
    //             $(document.body).trigger('wc_fragment_refresh');
    //             $('.cart-contents').click();
    //             $('.cart-button').click();
    //         },
    //         error: function(error) {
    //             console.log(error);
    //         }
    //     });
    // });    

    
    $('body').on('click', 'button, .button', function () {
        if ($(this).prop('disabled') || $(this).hasClass('disabled')) {
            return false;
        }
    });
  

    $(document).ajaxSend(function (event, jqXHR, settings) {
        if (settings.url.includes('add_to_cart')) {
            $('.add_to_cart_button').addClass('disabled', true);
        }
    });

    $(document).ajaxComplete(function (event, jqXHR, settings) {
        if (settings.url.includes('add_to_cart')) {
            $('.add_to_cart_button').removeClass('disabled', false);
        }
    });

    // display mini cart 
    $('body').on('click', '.cart-contents, .cover, .close-cart, .cart-button, .added_to_cart', function(){
        if(!$('body').hasClass('woocommerce-cart') && !$('body').hasClass('woocommerce-checkout')) {  
            if($('#menu-button').hasClass('active')) {          
                $('#menu-button').click();
            }        
            $('body').toggleClass('no-scroll');
            if ($('.mini-cart-container').length > 0 ) {
                $('.mini-cart-container').toggleClass('show');
                $('.cover.one').fadeToggle();
            }
            return false;
        }
    });

    // remove products from mini cart
    $('.mini-cart-container').on('click', '.remove-from-cart', function(e) {
        e.preventDefault();

        var cartItemKey = $(this).data('key');
        var nonce = $('.mini-cart-container').data('nonce');
        
        $('.mini-cart-container .cart-content').addClass('loading');
        $('.loader').show();

        $.ajax({
            type: 'POST',
            url: ajax.ajax.url,
            data: {
                action: 'remove_from_cart',
                cart_item_key: cartItemKey,
                nonce: nonce,
            },
            beforeSend: function() {
                // Show a loading spinner or other feedback here
            },
            success: function(data) {
                $(document.body).trigger('wc_fragment_refresh');
                $('.mini-cart-container .loading').removeClass('loading');
                $('.loader').hide();
            }
        });
    });
  
});


// WEBPACK FOOTER //
// ./resources/assets/js/partials/cart.js